<template>
    <div>
        <template v-if="subscription_fee == true">
            <div class="page-top mb-1 mb-3">
                <h1> Edit Subscription Charges </h1>
            </div>
          <div class="global-main">
            <form id="subscriptionFeeForm" @submit.prevent="editSubscriptionFeeData">
              <div class="tab-content-inner">
                <div class="form-group">
                  <label> Company </label>
                  <h2>{{company_name}}</h2>
                  <has-error :form="form" field="companyId"></has-error>
                </div>
                <div class="form-group">
                  <label> Charges </label>
                  <input v-model="form.charges" type="number" name="charges" class="form-control" :class="{ 'is-invalid': form.errors.has('charges') }">
                  <has-error :form="form" field="charges"></has-error>
                </div>
                <div class="form-group">
                  <label> Status </label>
                  <select v-model="form.status" name="status" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('status') }">
                    <option value="" selected>Select Status</option>
                    <option value="ON">ON</option>
                    <option value="OFF">OFF</option>
                  </select>
                  <has-error :form="form" field="status"></has-error>
                </div>
              </div>
              <div class="form-group">
                <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                <router-link to="/subscriptionFee" class="btn btn-primary float-right mr-2">Cancel</router-link>
              </div>
            </form>
          </div>
        </template>
        <template v-else-if="subscription_fee === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="subscription_fee === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
          return {
            form: new Form({
              company_id: "",
              charges: "",
              status: "",
            }),
            company_name: "",
            subscription_fee: null,
          };
        },
        methods: {
          editSubscriptionFeeData() {
                this.$Progress.start();
                this.form
                    .put("/api/updateSubscriptionFee")
                    .then((res) => {
                        if (res.status == 200) {
                            if (res.data.code == 200) {
                                this.resetForm();
                                this.$Progress.finish();
                                this.showToastBox("success", "Subscription Fee updated successfully");
                                this.$router.push("/subscriptionFee");
                            } else {
                                $(this.$el).find('.selectpicker').selectpicker('refresh');
                                this.showToastBox("error", res.data.message);
                            }
                        } else {
                            $(this.$el).find('.selectpicker').selectpicker('refresh');
                            this.$Progress.fail();
                            this.showAlertBox("error", "Some error in your form data");
                        }
                    })
                    .catch((err) => {
                        this.$Progress.fail();
                        const errorMessages = Object.entries(err.response.data.errors)
                            .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
                            .join('\n');
                        this.showAlertBox('error', `Validation errors:\n${errorMessages}`);
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                    });
            },
            resetForm() {
              this.form.company_id = "";
              this.form.charges = "";
              this.form.status = "";
            },
            getEditSubscriptionFeeData() {
                axios
                    .get("/api/editSubscriptionFee/" + this.$route.params.id)
                    .then((res) => {
                        if (res.status == 200) {
                            this.company_name = res.data.company_name;
                            this.form.company_id = res.data.company_id;
                            this.form.charges = res.data.charges;
                            this.form.status = res.data.status;
                            this.$Progress.finish();
                            setTimeout(function(){
                            $('.selectpicker').selectpicker('refresh');

                            },0)

                        } else {
                            $(this.$el).find('.selectpicker').selectpicker('refresh');
                            this.$Progress.fail();
                            this.showAlertBox("error", "error while loading data");
                        }
                    })
                    .catch((err) => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        this.$Progress.fail();
                        this.showAlertBox("error", "error while loading data");
                    });
            },
        },
        mounted() {
            this.$Progress.start();
            this.can("subscription_fee")
                .then((result) => {
                    this.subscription_fee = result.subscription_fee;
                })
                .then((result) => {
                    if (this.subscription_fee == true) {
                        this.getEditSubscriptionFeeData();
                        this.$Progress.finish();
                    } else {
                        this.$Progress.finish();
                    }
                    setTimeout(() => {
                        $('.selectpicker').selectpicker('refresh');
                    }, 1000);
                });
        },
    }
</script>
